import { motion, useReducedMotion } from "framer-motion";
import { useStudio } from "@/context/StudioContext";

export const HeroSection = () => {
    const { t, lang } = useStudio();
    const reduce = useReducedMotion();

    return (
        <section data-testid="hero-section" className="relative overflow-hidden">
            <div className="mx-auto flex max-w-7xl items-center px-6 pb-16 pt-28 sm:px-10 lg:px-16 lg:pb-20 lg:pt-36">
                <div className="max-w-4xl">
                    <h1
                        key={lang}
                        data-testid="hero-title"
                        className="font-display text-4xl font-light leading-[1.08] tracking-[-0.03em] text-foreground sm:text-5xl lg:text-6xl"
                    >
                        {t.hero.titleLines.map((line, i) => (
                            <span key={i} className="block overflow-hidden pb-1">
                                <motion.span
                                    className="block"
                                    initial={reduce ? { opacity: 0 } : { y: "115%" }}
                                    animate={reduce ? { opacity: 1 } : { y: "0%" }}
                                    transition={{ duration: 1.1, ease: [0.16, 1, 0.3, 1], delay: 0.25 + i * 0.15 }}
                                >
                                    {line}
                                </motion.span>
                            </span>
                        ))}
                    </h1>
                </div>
            </div>
        </section>
    );
};
